import { createTheme } from "@mui/material";

const paletteColors = {
  primary: {
    main: "#6366F1",
    light: "",
    dark:"#4338CA"
  },
  secondary: {
    main: "#1C2536",
    light: "",
  },
  aqua:{
    main: "#15B79E"
  },
  aquaNew:{
    main: "#ff867c"
  },
  white:{
    main: "#fff"
  },
  black:{
    main: "#000"
  },
  gray:{
    main: "#9da4ae"
  }
};

export const defaultTheme = createTheme({
  typography: {
    fontFamily: [
      "Aileron-Light",
      "-apple-system",
      "Aileron-Thin",
      "Aileron-Regular",
      "sans-serif",
      "Cinzel",
    ].join(","),
  },
  palette: { ...paletteColors,  },
  components: {
    MuiButton: {
      defaultProps :{
        disableElevation: true,
        variant: "contained",
      },
      styleOverrides: {
        root: {
          borderRadius: "48px",
          height: "48px",
          letterSpacing: "0.45px",
          padding: "0 1.25rem",
        }
      },
      variants: [
        {
          props: {
            size: "small"
          },
          style:{
            height: "32px",
            minWidth: "auto",
            fontSize: "12px",
            fontFamily: "Aileron-Thin",
            color: (theme)=> theme.palette.primary.main,
          }
        },
        {
          props:{
            variant: "contained",
            color: "primary"
          },
          style:{
            border:"1px solid transparent",
            ":hover":{
              border: "1px solid transparent",
              color: "#fff",
              backgroundColor: (theme)=> theme.palette.secondary.main,
            },
            fontFamily: "Aileron-Thin",
            fontWeight:"bold",
            letterSpacing: "2px",
          }
        },
        {
          props:{
            variant: "contained",
            color: "error"
          },
          style:{
            border:"1px solid transparent",
            ":hover":{
              border: "1px solid transparent",
              color: "#fff",
              backgroundColor: (theme)=> theme.palette.error.dark,
            },
            fontFamily: "Aileron-Thin",
            fontWeight:"bold",
            letterSpacing: "2px",
          }
        },
        {
          props:{
            variant: "contained",
            color: "warning"
          },
          style:{
            border:"1px solid transparent",
            ":hover":{
              border: "1px solid transparent",
              color: "#fff",
              backgroundColor: (theme)=> theme.palette.warning.dark,
            },
            fontFamily: "Aileron-Thin",
            fontWeight:"bold",
            letterSpacing: "2px",
          }
        }
      ]
    }
  }
});

defaultTheme.typography.h1 = {
  fontSize: "2rem",
  fontWeight: 300,
  lineHeight: "30px",
  fontFamily: "Aileron-Regular",
};

defaultTheme.typography.h2 = {
  fontSize: "20px",
  fontWeight: 400,
  lineHeight: "30px",
};

defaultTheme.typography.h3 ={
  fontSize: "18px",
  fontWeight: 400,
  lineHeight: "30px",
}

